'use strict';

module.exports.elementToString = function(e) {
  if (!e) {
    return '<null>';
  }

  return '<' + e.$type + (e.id ? ' id="' + e.id : '') + '" />';
};


// WEBPACK FOOTER //
// ./~/bpmn-js/lib/import/Util.js